module.exports = __webpack_public_path__ + "static/img/service_safeguard_center.74f1d56e.svg";